import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import fakeModalData from './fakeModalData';
import Screens from '../../screens';
var CheatMenu = /*#__PURE__*/function (_Component) {
  function CheatMenu() {
    var _this;
    _classCallCheck(this, CheatMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CheatMenu, [].concat(args));
    _this.state = {
      modal: '',
      gameId: 0
    };
    _this.handleModalChange = function (modal) {
      _this.setState({
        modal: modal
      });
    };
    _this.handleGoToModalClick = function () {
      var modal = _this.state.modal;
      if (modal === '') return;
      var fakeData = fakeModalData[modal] || {};
      var fakeParams = fakeData.params || {};
      var fakeDataSetup = fakeData.setup;
      if (fakeDataSetup) fakeDataSetup();
      QueryParamsProxy.setQueryParams(_objectSpread(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modal), RouteParamConstants.PARAM_CHEAT_MENU_ACTIVE, true), fakeParams));
    };
    _this.handleTestGame = function () {
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Game, _defineProperty(_defineProperty({}, RouteParamConstants.PARAM_GAME_ID, _this.state.gameId), RouteParamConstants.PARAM_CHEAT_MENU, 'yes'));
    };
    _this.handleGameIdChange = function (gameId) {
      _this.setState({
        gameId: gameId
      });
    };
    return _this;
  }
  _inherits(CheatMenu, _Component);
  return _createClass(CheatMenu, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        modal = _this$state.modal,
        gameId = _this$state.gameId;
      return this.props.render({
        modal: modal,
        gameId: gameId,
        handleModalChange: this.handleModalChange,
        handleGoToModalClick: this.handleGoToModalClick,
        handleGameIdChange: this.handleGameIdChange,
        handleTestGame: this.handleTestGame
      });
    }
  }]);
}(Component);
export { CheatMenu as default };